import {useState} from 'react';
import {Card, Row, Col, InputNumber, Modal, Divider} from 'antd';

export const ProductCard = ({item, onCostChange, props}) => {
    const [modalOpen, setModalOpen] = useState(false);
    const [cost, setCost] = useState(item.cost);
    const [startQuantity, setStartQuantity] = useState(item.startQuantity);

    const labelStyle = {
        width: 150,
        fontWeight: 'bold',
    }
    const valueStyle = {
    }

    const modalLabelStyle = {
        width: 150,
        fontWeight: 'bold',
        marginTop: '5px'
    }

    const rowStyle = {
        marginTop: '5px',
        marginBottom: '5px'
    }

    const onCostClick = () => {
        setModalOpen(true);
    }

    const onOk = () => {
        if (onCostChange) {
            onCostChange({
                startQuantity, cost
            })
        }
        setModalOpen(false);
    }

    const onCancel = () => {
        setModalOpen(false);
        setCost(item.cost);
        setStartQuantity(item.startQuantity);
    }

    const onCostValueChange = (val) => {
        setCost(val);
    }

    const onQuantityChange = (val) => {
        setStartQuantity(val);
    }

    return <Card title={<div><b>Cost Basis</b></div>} width={400}>
        <Modal title={`Set Cost Basis for ${item.name}`} open={modalOpen} onOk={onOk} onCancel={onCancel}>
            <Divider />
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Cost:</Col>
                <Col style={valueStyle}><InputNumber addonBefore={'$'} value={cost} onChange={onCostValueChange} precision={2} /></Col>
            </Row>
            <Row style={rowStyle}>
                <Col style={modalLabelStyle}>Start Quantity:</Col>
                <Col style={valueStyle}><InputNumber value={startQuantity} onChange={onQuantityChange} precision={2} /></Col>
            </Row>
        </Modal>
        <Row>
            <Col style={labelStyle}>Cost:</Col>
            <Col style={valueStyle}><div onClick={onCostClick} style={{cursor: 'pointer', color: "#108ee9"}}>{`$ ${item.cost}`}</div></Col>
        </Row>
        <Row>
            <Col style={labelStyle}>Start Quantity:</Col>
            <Col style={valueStyle}>{`${item.startQuantity}`}</Col>
        </Row>
    </Card>
}